import { render, staticRenderFns } from "./RelayControl.vue?vue&type=template&id=3f664ace&scoped=true&"
import script from "./RelayControl.vue?vue&type=script&lang=js&"
export * from "./RelayControl.vue?vue&type=script&lang=js&"
import style0 from "./RelayControl.vue?vue&type=style&index=0&id=3f664ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f664ace",
  null
  
)

export default component.exports